/* angular:styles/component:css;1d9a5060e0ea17811b0c6c32507e6a0cae376711ca03d1ed141739ab975a40f6;/src/src/app/shared/components/schedule/edit/edit-task.component.ts */
::ng-deep formly-form {
  height: 100% !important;
}
/*# sourceMappingURL=edit-task.component.css.map */
